var RGB = function(red, green, blue){
  this.red = red;
  this.green = green;
  this.blue = blue;
};

module.exports = RGB;


// WEBPACK FOOTER //
// ./src/componentes/lib/rtf/rgb.js